import http from '../plugins/axios'

const resource = '/api/v1/slider-landing-page'

export default {
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
}
